module.exports = __webpack_public_path__ + "static/media/Articles 3.b5865dc5.svg";